import {Box, Tab, Tabs} from "@mui/material";
import {DEFAULT_COLOR_THEME} from "crqlar-react-common/dist/components/theme";
import type {Organization} from "crqlar-react-common/dist/models/organization/organization";
import {useSelector} from "react-redux";
import {Link as RouterLink} from "react-router-dom";
import type {TabRoute} from "./PageShell";

interface Props {
    tabs: TabRoute[];
    value: string;
    compact: boolean;
}

export function PageShellDesktopTabs({tabs, value, compact}: Props) {
    const organization = useSelector<any, Organization | undefined>(
        state => state.auth.organization,
    );
    const activeColor =
        organization?.theme?.primary?.main ?? DEFAULT_COLOR_THEME.primary.main;

    return (
        <Box
            className="hide-on-print"
            sx={{
                display: compact ? "none" : "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 44,
                flexShrink: 0,
            }}
        >
            <Tabs
                value={value}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="page sections"
                sx={{
                    minHeight: 44,
                    "& .MuiTabs-indicator": {
                        backgroundColor: activeColor,
                    },
                    "& .MuiTabs-flexContainer": {
                        justifyContent: "center",
                    },
                    "& .MuiTabs-scrollButtons.Mui-disabled": {
                        display: "none",
                    },
                    "& .MuiTab-root": {
                        minHeight: 44,
                        opacity: 0.6,
                        borderTop: "1px solid transparent",
                        borderLeft: "1px solid transparent",
                        borderRight: "1px solid transparent",
                        textDecoration: "none",
                    },
                    "& .MuiTab-root.Mui-selected": {
                        opacity: 1,
                        bgcolor: "#fff",
                        color: "text.primary",
                        borderTopColor: "rgba(15, 23, 42, 0.08)",
                        borderLeftColor: "rgba(15, 23, 42, 0.08)",
                        borderRightColor: "rgba(15, 23, 42, 0.08)",
                        borderRadius: 2,
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                    },
                }}
            >
                {tabs.map(tab => (
                    <Tab
                        key={tab.path}
                        component={RouterLink}
                        to={tab.path}
                        label={tab.label}
                        value={tab.path}
                    />
                ))}
            </Tabs>
        </Box>
    );
}
